module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-8-inverse-d5cbf1a03e0f8b9ac5a311f563796e3f.png";